module.exports = __webpack_public_path__ + "static/media/autodeterminacion.0989483e.jpg";